<div class="camera-container">
  <webcam
    *ngIf="showWebcam"
    [height]="120"
    [width]="120"
    [imageQuality]="0.3"
    [trigger]="invokeObservable"
    [allowCameraSwitch]="allowCameraSwitch"
    (imageCapture)="handleImage($event)"
    (initError)="handleInitError($event)"
    (cameraSwitched)="cameraWasSwitched($event)"
  ></webcam>
  <p *ngIf="webCamPermissionDenied" class="camera-error">{{pageUiString.camera_on}}</p>
</div>
